import React from 'react';
import IconX from '!svg-react-loader?!images-react-svg/icons/icon-x.svg';

import PriceSpan from 'common/components/formatters/PriceSpan';
import { TranslatedMessage } from 'common/components/Intl';

const CheckoutDrawerListItem = ({ quantity, title, priceAmount }) => (
  <li className="build-your-plan__drawer-item">
    <span className="build-your-plan__drawer-name">
      <strong>{quantity}</strong>
      {title}
    </span>
    <span className="build-your-plan__drawer-price">
      <PriceSpan amount={priceAmount} />
    </span>
  </li>
);

export default function CheckoutDrawer({
  selectedPods,
  selectedAddOns,
  closeModal,
}) {
  const closeFromBackground = event => {
    // The close icon is an svg element, and svg elements className attribute
    // is an object of SVGAnimatedString type. In this case we still want to
    // close it, but need to be careful `match`-ing it.
    const className =
      typeof event.target.className === 'string' ? event.target.className : '';
    if (className.match(/drawer-modal/)) {
      closeModal();
    } else {
      event.stopPropagation();
    }
  };

  const podListItems = Object.values(selectedPods).map(pod => (
    <CheckoutDrawerListItem
      key={pod.offeringId}
      quantity={pod.quantity}
      title={
        <>
          {` x ${pod.name}, ${pod.nicotine_strength_percent}, `}
          <TranslatedMessage
            id="cart.pod_count"
            values={{ pod_count: pod.pod_quantity }}
          />
        </>
      }
      priceAmount={(pod.price * pod.quantity) / 100} // Pods prices are an integer
    />
  ));

  const addOnListItems = Object.values(selectedAddOns).map(addOn => (
    <CheckoutDrawerListItem
      key={addOn.offering.id}
      quantity={addOn.quantity}
      title={` x ${addOn.product.title}`}
      priceAmount={addOn.product.price * addOn.quantity} // Product prices are a float
    />
  ));

  const listItems = [...podListItems, ...addOnListItems];

  return (
    <div
      className="Modal build-your-plan__drawer-modal"
      onClick={closeFromBackground}
    >
      <div className={'build-your-plan__checkout-drawer'}>
        <IconX
          height={13}
          width={13}
          className={'build-your-plan__drawer-close-icon'}
          onClick={closeModal}
        />
        {listItems.length > 0 ? (
          <ul className="text--body--small">{listItems}</ul>
        ) : (
          <TranslatedMessage id="plan_builder.cart.empty" />
        )}
      </div>
    </div>
  );
}
